/** Reserve the existing media box; fetch campaign imagery shortly before it is visible.
 * Native lazy loading may fetch several screens of full-resolution campaign imagery.
 * A template keeps those requests out of the hero's critical path. No image rewriting.
 */
class HunnaDeferredImage extends HTMLElement {
  #observer;

  connectedCallback() {
    if (this.#observer || !this.querySelector('template')) return;
    if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
      this.#load();
      return;
    }
    this.#observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) this.#load();
    }, { rootMargin: '400px 0px' });
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #load() {
    this.#observer?.disconnect();
    this.#observer = null;
    const template = this.querySelector('template');
    if (template) this.replaceChildren(template.content);
  }
}

if (!customElements.get('hunna-deferred-image')) customElements.define('hunna-deferred-image', HunnaDeferredImage);
